module.exports = __webpack_public_path__ + "assets/img/per-21451ee1.png";